import type { PropsWithChildren } from 'react';

import styled from '@emotion/styled';
import { media } from '@myrealtrip/modash';

import CommonLayout from '~components/CommonLayout';

interface Props {
  hideHeader?: boolean;
  hideFooter?: boolean;
}

export default function MessengerPageLayout({
  hideHeader,
  hideFooter,
  children,
}: PropsWithChildren<Props>) {
  return (
    <CommonLayout hideHeader={hideHeader} hideFooter={hideFooter}>
      <MessengerContainer>{children}</MessengerContainer>
    </CommonLayout>
  );
}

const MessengerContainer = styled.div<{ desktopJustifyContent?: 'center' | 'flex-start' }>`
  width: 100vw;
  height: 100%;
  background-color: white;
  z-index: 1;

  ${media.minMobile} {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: 850px;
    padding: 48px 0;
    background-color: ${({ theme }) => theme.colors.gray.s60};
  }
`;
